/**
 * MaintenanceScreen - Displayed when platform is in maintenance mode
 */
import React from 'react';
import { AlertTriangle, Wrench } from 'lucide-react';

const MaintenanceScreen = ({ message }) => {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        maxWidth: '400px',
        textAlign: 'center',
      }}>
        {/* Animated Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 24px',
          background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(0, 0, 0, 0.3) 100%)',
          border: '2px solid rgba(245, 158, 11, 0.3)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'pulse 2s ease-in-out infinite',
        }}>
          <Wrench size={36} color="#F59E0B" />
        </div>

        {/* Title */}
        <h1 style={{
          fontSize: '24px',
          fontWeight: 700,
          color: '#fff',
          margin: '0 0 12px',
        }}>
          Under Maintenance
        </h1>

        {/* Message */}
        <p style={{
          fontSize: '14px',
          color: 'rgba(255, 255, 255, 0.6)',
          lineHeight: 1.6,
          margin: '0 0 24px',
        }}>
          {message || 'We\'re performing scheduled maintenance. Please check back soon.'}
        </p>

        {/* Status Card */}
        <div style={{
          padding: '16px',
          background: 'rgba(245, 158, 11, 0.1)',
          border: '1px solid rgba(245, 158, 11, 0.2)',
          borderRadius: '12px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
        }}>
          <AlertTriangle size={20} color="#F59E0B" />
          <span style={{ fontSize: '12px', color: '#F59E0B' }}>
            All services temporarily unavailable
          </span>
        </div>

        {/* Logo */}
        <div style={{
          marginTop: '40px',
          fontSize: '18px',
          fontWeight: 700,
          color: 'rgba(255, 255, 255, 0.3)',
        }}>
          YoBitch.fun
        </div>
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.05); opacity: 0.8; }
        }
      `}</style>
    </div>
  );
};

export default MaintenanceScreen;
